import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useHasRole } from '@/hooks/useSession';
import { updateTransmitter } from '../api';
import { transmittersKeys } from './useTransmitters';
import type { TransmitterFormData } from '../types';

/**
 * Mutation to update a transmitter via V2 PUT endpoint.
 * Invalidates all transmitter queries on success.
 */
export function useUpdateTransmitter(transmitterId: string) {
  const queryClient = useQueryClient();
  const isAdmin = useHasRole('full_admin');

  return useMutation({
    mutationFn: (data: Partial<TransmitterFormData>) =>
      updateTransmitter(transmitterId, data, isAdmin),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: transmittersKeys.all });
      toast.success('Transmitter updated');
    },
    onError: (error) => {
      const message =
        error instanceof Error ? error.message : 'Unknown error';
      toast.error('Failed to update transmitter', { description: message });
    },
  });
}
